export default {
  namespaced: true,
  state: {
    bannersList: [],
  },
  actions: {
    GetBannersList({ commit, rootGetters }) {
      rootGetters.ax.post('posters/api/posters/by-group', { group: 'guest-index' })
        .then((response) => {
          commit('setBannersList', response.data.banners);
        });
    },
  },
  mutations: {
    setBannersList(state, payload) {
      state.bannersList = payload;
    },
  },
};
